import React, { useState, useEffect } from 'react';
import styles from './ProgramDirectors.module.scss';
import PageTitle from '../../../components/pageTitle/PageTitle';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import StudentAllocationCard from '../../../components/studentAllocationCard/StudentAllocationCard';
import LoadMore from '../../../components/loadMore/loadMore';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';

const limit = 20;

const ProgramDirectors = () => {
  const navigate = useNavigate();
  const { showToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadMoreLoading, setIsLoadMoreLoading] = useState(false);
  const [programDirectors, setProgramDirectors] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      if (page === 1) {
        setIsLoading(true);
      } else {
        setIsLoadMoreLoading(true);
      }
      try {
        const response = await axiosClient.get('users/program-director-management/program-directors', {
          params: { limit, page },
        });
        const data = response.data;
        if (page === 1) setProgramDirectors([]);
        setProgramDirectors(prev => [
          ...prev,
          ...data.programDirectors.map(pd => ({
            id: pd.id,
            profilePicture: pd.profilePicture ?? null,
            firstName: pd.firstName ?? '',
            lastName: pd.lastName ?? '',
            tag: { text: pd.isActive ? 'Active' : 'Inactive', variant: pd.isActive ? 5 : 6 },
            data: [
              { label: 'Email', value: pd.email ?? '' },
              { label: 'Phone', value: pd.phone ?? '' },
              {
                label: 'Subscription',
                value: pd.subscriptions?.length > 0
                  ? `${pd.subscriptions[0].name}${pd.subscriptions.length > 1 ? ` +${pd.subscriptions.length - 1}` : ''}`
                  : '—',
                tooltip: pd.subscriptions?.length > 1
                  ? pd.subscriptions.map(s => s.name).join(', ')
                  : '',
              },
            ],
          })),
        ]);
        setTotalPages(data.totalPages);
      } catch (error) {
        showToast(error.message || 'Failed to fetch program directors', 'error');
      } finally {
        setIsLoading(false);
        setIsLoadMoreLoading(false);
      }
    };

    fetchData();
  }, [page, showToast]);

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle label="Program Directors" />
        <Button
          label={<div className={styles.cta}><Icon name="plus" />Add Program Director</div>}
          variant="primary"
          size="medium"
          onClick={() => navigate('/program-directors/create')}
        />
      </div>
      <div className={styles.container}>
        {programDirectors.length > 0 ? (
          <div className={styles.cardList}>
            {programDirectors.map((pd, index) => (
              <div key={`pd-${index}`} className={styles.cardItem}>
                <StudentAllocationCard
                  {...pd}
                  showActions
                  actions={[{ label: 'Edit', onClick: () => navigate(`/program-directors/edit/${pd.id}`) }]}
                  onClick={() => navigate(`/program-directors/edit/${pd.id}`)}
                />
              </div>
            ))}
            {(isLoadMoreLoading || page < totalPages) && (
              <LoadMore isLoading={isLoadMoreLoading} onClick={() => setPage(p => p + 1)} />
            )}
          </div>
        ) : (
          !isLoading && <div className={styles.empty}><p>No program directors found.</p></div>
        )}
      </div>
    </>
  );
};

export default ProgramDirectors;
